import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=d9f90c9c&scoped=true&"
import script from "./Assess.vue?vue&type=script&lang=js&"
export * from "./Assess.vue?vue&type=script&lang=js&"
import style0 from "./Assess.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Assess.vue?vue&type=style&index=1&id=d9f90c9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f90c9c",
  null
  
)

export default component.exports